import { useMyGroups, useMyOrganizations } from '@ilteducation/my-account';
import { useAppEvents } from '../events/appEvents';
import { isGroupLevelRestriction } from '@ilteducation/customer-mgmt-permissions';
import { usePermissions } from './usePermissions';

export function useEventStateManager() {
  const { invalidateGroups } = useMyGroups();
  const { onAppEvent } = useAppEvents();
  const { organizations } = useMyOrganizations();
  const { clearTargetMembershipsCache, permissionContext, revalidatePermissionCaches } = usePermissions();

  onAppEvent((event) => {
    switch (event.type) {
      case 'group:created': {
        const organization = organizations.value.data.find((o) => o.uid === event.organizationUid);
        if (organization && isGroupLevelRestriction(organization)) {
          invalidateGroups();
        }
        break;
      }

      case 'membership:updated': {
        // Permission caches only affect gating in group-restricted orgs — skip otherwise.
        const organization = organizations.value.data.find((o) => o.uid === event.organizationUid);
        if (!organization || !isGroupLevelRestriction(organization)) {
          break;
        }
        // Drop cached target memberships and lazily refresh the caller's own groups.
        clearTargetMembershipsCache();
        invalidateGroups();
        break;
      }

      case 'association:updated': {
        clearTargetMembershipsCache();
        if (event.userUids.includes(permissionContext.value.sub)) {
          revalidatePermissionCaches();
        }
        break;
      }

      default:
        break;
    }
  });
}
